// ParfumChef Sepet Koruması
// Tester paketi 5 parfüm seçilmeden sepete girerse (quick-add, direkt istek vb.
// hangi yoldan olursa olsun) ürünü sepetten çıkarır ve müşteriyi uyarır.
(function() {
  var REQUIRED_COUNT = 5;
  var KNOWN_PROP_KEYS = ['tester_secimi', 'Seçilen Parfümler'];
  var busy = false;

  function isTesterItem(item) {
    return (item.product_title || '').toLowerCase().indexOf('tester') !== -1;
  }

  function hasEnoughPerfumes(properties) {
    if (!properties) return false;
    var keys = Object.keys(properties);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (key.charAt(0) === '_') continue; // gizli propertyler
      var value = properties[key];
      if (typeof value !== 'string' || value.trim() === '') continue;
      var parts = value.split(',').filter(function(s) { return s.trim() !== ''; });
      // 5+ parçalı bir liste görürsek parfüm seçimi yapılmış sayarız
      if (parts.length >= REQUIRED_COUNT) return true;
    }
    return false;
  }

  function showAlert(message) {
    var alertBox = document.getElementById('pchef-custom-alert');
    if (!alertBox) {
      alertBox = document.createElement('div');
      alertBox.id = 'pchef-custom-alert';
      Object.assign(alertBox.style, {
        position: 'fixed',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#333',
        color: 'white',
        padding: '12px 24px',
        borderRadius: '50px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
        zIndex: '100000',
        fontFamily: 'inherit',
        fontSize: '14px',
        transition: 'all 0.4s ease',
        opacity: '0',
        pointerEvents: 'none',
        maxWidth: '90vw',
        textAlign: 'center'
      });
      document.body.appendChild(alertBox);
    }
    alertBox.innerText = message;
    alertBox.style.opacity = '1';
    alertBox.style.bottom = '50px';
    setTimeout(function() {
      alertBox.style.opacity = '0';
      alertBox.style.bottom = '30px';
    }, 5000);
  }

  async function enforce() {
    if (busy) return;
    busy = true;
    try {
      var cartResp = await fetch('/cart.js');
      var cart = await cartResp.json();
      var badItems = (cart.items || []).filter(function(item) {
        return isTesterItem(item) && !hasEnoughPerfumes(item.properties);
      });
      if (badItems.length === 0) return;

      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function(el) {
        if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      var lastData = null;
      for (var i = 0; i < badItems.length; i++) {
        var resp = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: badItems[i].key,
            quantity: 0,
            sections: sectionIds.join(',')
          })
        });
        lastData = await resp.json();
      }

      if (lastData) {
        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = {
          resource: lastData,
          sourceId: 'pchef-cart-guard',
          data: {
            source: 'pchef-cart-guard',
            itemCount: lastData.item_count,
            sections: lastData.sections || {}
          }
        };
        document.dispatchEvent(evt);
      }

      showAlert('Tester paketi için 5 parfüm seçilmeden sipariş verilemez. Ürün sepetten çıkarıldı, lütfen ürün sayfasından parfümlerinizi seçerek ekleyin.');
    } catch (err) {
      console.error('PChef sepet koruması hatası:', err);
    } finally {
      busy = false;
    }
  }

  // Sepet her güncellendiğinde kontrol et (kendi tetiklediğimiz olayı atla)
  document.addEventListener('cart:update', function(e) {
    if (e.detail && e.detail.data && e.detail.data.source === 'pchef-cart-guard') return;
    setTimeout(enforce, 100);
  });

  // Sayfa açılışında da kontrol et (önceden sızmış kayıtları temizler)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(enforce, 300); });
  } else {
    setTimeout(enforce, 300);
  }
})();
